export default "__VITE_ASSET__CtU1Ei0B__"